import { useQuery } from '@tanstack/react-query'

import { api } from './api'

// Qué módulos usa el local.
//
// El backend es el que decide (ver Domain/Entities/Modulos.cs): acá solo se
// consulta y se responde «¿está prendido?». Los dos hosts sirven la MISMA ruta
// —la nube y el ejecutable del mostrador—, así que el menú y las pantallas se
// esconden igual contra cualquiera de los dos, y en la caja funciona sin
// internet porque los parámetros bajan por sincronización.
//
// Lo que decide un módulo es qué FUNCIONES tiene el local, y es distinto de lo
// que decide el menú (`MenuNode`, que acomoda orden, nombre y visibilidad de lo
// que existe). La diferencia importa: un módulo apagado hace que sus endpoints
// contesten 404, así que dejar su ítem en el menú sería un menú que lleva a una
// pantalla que no puede cargar.

export type Modulos = Record<string, boolean>

export const consultaModulos = {
  queryKey: ['modulos'],
  queryFn: () => api.get<Modulos>('/modulos', { destino: 'local' }),

  // Cambia cuando el dueño lo toca en Configuración, o sea casi nunca. Se
  // cachea toda la sesión y la pantalla de parámetros invalida la consulta al
  // guardar.
  staleTime: Infinity,
}

/**
 * `activo(codigo)` para las pantallas.
 *
 * Mientras la consulta no responde —el primer render, o una caja que todavía
 * no sincronizó— TODO cuenta como prendido, y esa es la dirección segura: al
 * revés, el menú aparecería vacío medio segundo en cada carga y una pantalla
 * que el local sí usa se vería como inexistente. El servidor decide igual: si
 * el módulo está apagado de verdad, sus endpoints contestan 404.
 */
export function useModulos() {
  const { data } = useQuery(consultaModulos)

  return {
    modulos: data,
    activo: (codigo: string) => data?.[codigo] !== false,
  }
}
